import moment from "moment";
import _prettyMs from "pretty-ms";

export const prettyMs = (_time_ms) => {
  const time_ms = parseInt(_time_ms);
  if (isNaN(time_ms)) return undefined;
  return _prettyMs(time_ms);
};

export const localTime = (input, format) => {
  if (input == undefined) return null;

  format = format || "YYYY-MM-DD HH:mm";

  const date = moment(input).format(format);
  return date;
};

// originally transformText
export const actionIdToLabel = (actionId) => {
  try {
    const [type, id] = actionId.split("--");
    if (type === "animation") {
      if (id === "Root|740428|BaseLayer".toLowerCase()) return "하암 !@!";
      else if (id === "dance") return "댄스타임";
      else if (id === "hi") return "안녕하세요 :)";
      else if (id === "deahat") return "데햇 >.<";
      else if (id === "die") return "죽는다!!";
      else if (id === "agree") return "동의하는 바이오";
      else if (id === "angry") return "매우 화남";
      else if (id === "embarrassment") return "화들짝";
      else if (id === "happy") return "행복해^^";
      else if (id === "thankyou") return "감사합니다";
    } else if (type === "camera") {
      if (id === "restore") return "카메라 복구";
    }

    return id;
  } catch (error) {
    console.log(error);
    return "-";
  }
};
